import {
  ActionIcon,
  Avatar,
  Flex,
  Input,
  Modal,
  Pagination,
  Popover,
  Select,
  Table,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { deleteNotification } from "../../utils/useNotification";
import {
  deleteTerminal,
  getLocateList,
  getTerminalList,
} from "../../api/terminalApi";
import TerminalUpdateForm from "./TerminalUpdateForm";
import { useLocation, useNavigate } from "react-router";
import styled from "styled-components";
import TableEditButton from "../common/Buttons/TableEditButton";
import TableDeleteButton from "../common/Buttons/TableDeleteButton";
import AreYouSureModal from "../common/Modals/AreYouSureModal";
import CustomSelect from "../common/Inputs/CustomSelect";
import CustomSearchInput from "../common/Inputs/CustomSearchInput";
import CustomPagination from "../common/CustomPagination";

const TabletsTable = () => {
  const [clickedTerminal, setClickedTerminal] = useState<any>();
  const [tableData, setTableData] = useState<any>();
  const navigate = useNavigate();
  const location = useLocation();
  //for pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  //for edit modal
  const [opened, setOpened] = useState(false);
  //for delete modal
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [itemToDeleteId, setitemToDeleteId] = useState<any>();
  //for select
  const [selectData, setSelectData] = useState<any>();
  const [selectedLocate, setSelectedLocate] = useState<any>();
  //for sort
  const [sort, setSort] = useState<any>("");
  //for search
  const [searchedName, setSearchedName] = useState<any>();

  const getTableData = async () => {
    try {
      const { data }: any = await getTerminalList({
        pageNumber: page,
        limit: limit,
        sort,
        locate: selectedLocate,
        name: searchedName,
      });
      setTableData(data?.data);
      setPage(data?.meta?.page);
      setLimit(data?.meta?.limit);
      setTotalPages(data?.meta?.totalPages);
      setTotalItems(data?.meta?.total);
    } catch (error) {}
  };

  const getLocates = async () => {
    try {
      const { data }: any = await getLocateList();
      setSelectData(data);
    } catch (error) {}
  };

  useEffect(() => {
    if (page) {
      getTableData();
    }
  }, [page, opened, searchedName, sort, selectedLocate]);

  useEffect(() => {
    getLocates();
  }, []);

  const handleDeleteClick = async (id: any) => {
    try {
      const { data }: any = await deleteTerminal({
        id,
      });
      deleteNotification(data?.success);
      const { data: updatedList }: any = await getTerminalList({
        pageNumber: page,
        limit: limit,
      });
      setTableData(updatedList?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            overflowY: "auto",
            height: "422px",
            width: "100%",
            border: "1px solid #D1D5DB",
            borderRadius: "6px",
          }}
        >
          <Flex p={"12px 16px"} justify={"space-between"}>
            <CustomSearchInput
              value={searchedName}
              w={220}
              placeholder="Tablet Adı"
              onChange={(event: any) => {
                setPage(1);
                setSearchedName(event.currentTarget.value);
              }}
            />
            <Flex gap={8}>
              <CustomSelect
                placeholder="Tablet Konumu"
                data={selectData}
                onChange={(e: any) => {
                  setSelectedLocate(e);
                  setPage(1);
                }}
              />
            </Flex>
          </Flex>
          <Table
            style={{
              borderCollapse: "separate",
            }}
            verticalSpacing="sm"
          >
            <Table.Thead
              style={{
                background: "#EEF2FF",
              }}
            >
              <Table.Tr>
                <StyledTableTh style={{ width: "20%" }}>
                  <Flex gap={4}>
                    <Flex
                      gap={4}
                      style={{
                        cursor: "pointer",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setSort((prev: string) =>
                          prev === "desc" ? "asc" : "desc"
                        );
                      }}
                    >
                      <div>Tablet Adı</div>
                      {sort === "desc" ? (
                        <Avatar src={"/assets/ascSortIcon.png"} size={16} />
                      ) : (
                        <Avatar src={"/assets/descSortIcon.png"} size={16} />
                      )}
                    </Flex>
                  </Flex>
                </StyledTableTh>
                <StyledTableTh style={{ width: "20%" }}>
                  Terminal Kodu
                </StyledTableTh>
                <StyledTableTh style={{ width: "20%" }}>
                  Tablet Konumu
                </StyledTableTh>
                <StyledTableTh style={{ width: "1%" }}></StyledTableTh>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {tableData?.map((tablet: any) => (
                <StyledTableTr
                  key={tablet?._id}
                  style={{
                    color: "#111827",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                >
                  <Table.Td>{tablet?.name}</Table.Td>
                  <Table.Td>{tablet?.code}</Table.Td>
                  <Table.Td>{tablet?.location}</Table.Td>
                  <Table.Td>
                    <Flex gap={12}>
                      <TableEditButton
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setClickedTerminal(tablet);
                          setOpened(true);
                        }}
                      />
                      <TableDeleteButton
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setitemToDeleteId(tablet?._id);
                          setOpenDeleteModal(true);
                        }}
                      />
                    </Flex>
                  </Table.Td>
                </StyledTableTr>
              ))}
            </Table.Tbody>
          </Table>
        </div>

        <div
          style={{
            paddingTop: "24px",
          }}
        >
          <CustomPagination
            total={totalPages}
            value={page}
            onChange={setPage}
          />
        </div>
      </div>
      <Modal
        opened={opened}
        title="Tablet Bilgisi Düzenleme"
        centered
        onClose={() => {
          setOpened(false);
        }}
        withCloseButton={true}
        keepMounted={false}
        key={clickedTerminal?._id}
      >
        <TerminalUpdateForm
          closeModal={() => setOpened(false)}
          tablet={clickedTerminal}
        />
      </Modal>
      <AreYouSureModal
        opened={openDeleteModal}
        setOpened={setOpenDeleteModal}
        proccessFunc={() => handleDeleteClick(itemToDeleteId)}
        title="Tablet Sil"
        text="Bu tableti silmek istediğinizden emin misiniz?"
        confirmButtonText="Sil"
        cancelButtonText="Vazgeç"
      />
    </>
  );
};

export default TabletsTable;

const StyledTableTh = styled(Table.Th)`
  color: #4c4c4c;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

const StyledTableTr = styled(Table.Tr)``;
